import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Api } from '../api/api';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
// import { query } from '@angular/core/src/animation/dsl';
import { GeoFenceProvider } from './../geo-fence/geo-fence';

/*
  Generated class for the MatchmakingProvider provider.
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MatchmakingProvider {
  constructor(private api: Api, public geo: GeoFenceProvider) {}

  getContacts(): Observable<any> {
    return this.api.post('user/getContacts', {}).map(res => {
      return res;
    });
  }

  getEvenContacts(eventId: string): Observable<any> {
    return this.api.get('matchmaking/contacts', { event: eventId }).map(res => {
      return res;
    });
  }

  searchEventContactsPaginated(
    eventId: string,
    query: string,
    pageNum: number,
    pageSize: number
  ): Observable<any> {
    return this.api
      .get('matchmaking/contacts/paginated', {
        event: eventId,
        search: query,
        pageNumber: pageNum,
        pageSize: pageSize,
      })
      .map(res => {
        return res;
      });
  }

  searchEventPicksPaginated(
    eventId: string,
    query: string,
    pageNum: number,
    pageSize: number
  ): Observable<any> {
    return this.api
      .get('matchmaking/picks/paginated', {
        event: eventId,
        search: query,
        pageNumber: pageNum,
        pageSize: pageSize,
      })
      .map(res => {
        return res;
      });
  }
  getEventUsers(eventId: string): Observable<any> {
    return this.api.get('matchmaking/list', { event: eventId }).map(res => {
      return res;
    });
  }
  getEventUsersPaginated(
    eventId: string,
    query: string,
    pageNum: number,
    pageSize: number
  ): Observable<any> {
    this.geo.readAndSendLocation();
    return this.api
      .get('matchmaking/list/paginated', {
        event: eventId,
        search: query,
        pageNumber: pageNum,
        pageSize: pageSize,
      })
      .map(res => {
        return res;
      });
  }

  // getEventUsersPaginaited(
  //   eventId: string,
  //   query: string,
  //   pageNum: number,
  //   pageSize: number
  // ): Observable<any> {

  //   return Observable.fromPromise(
  //     this.api.get(
  //       'matchmaking/list/paginated?event=' +
  //         eventId +
  //         '&search=' +
  //         query +
  //         '&pageNumber=' +
  //         pageNum +
  //         '&pageSize=' +
  //         pageSize,
  //       {}
  //     )
  //   ).mergeMap(res => {
  //     return res;
  //   });
  // }

  getEventPicks(eventId: string): Observable<any> {
    return this.api.get('matchmaking/picks', { event: eventId }).map(res => {
      return res;
    });
  }

  addPick(userId: string): Observable<any> {
    return this.api.post('user/addFavorite', { user: userId }).map(res => {
      return res;
    });
  }

  removePick(userId: string): Observable<any> {
    return this.api.post('user/removeFavorite', { user: userId }).map(res => {
      return res;
    });
  }

  checkUserStatus(eventId: number): Observable<any> {
    return this.api
      .post('events/getUserVisibilityOnEvent', { eventId: eventId })
      .map(res => {
        return res;
      });
  }

  updateUserStatus(eventId: number, isVisible: boolean): Observable<any> {
    return this.api
      .post('events/setUserVisibilityOnEvent', {
        eventId: eventId,
        visible: isVisible,
      })
      .map(res => {
        return res;
      });
  }
  postUserProfileOnEvent(eventId: string): Observable<any> {
    return this.api
      .post(`events/skipUserProfileOnEvent?eventUuid=${eventId}`, {})
      .map(res => {
        return res;
      });
  }

  getUserProfileOnEvent(eventId: string): Observable<any> {
    return this.api
      .get('events/getUserProfileOnEvent', { eventUuid: eventId })
      .map(res => {
        return res;
      });
  }

  updateUserProfileOnEvent(body: any): Observable<any> {
    return this.api
      .post('events/updateOrCreateUserProfileOnEvent', body)
      .map(res => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/matchmaking/matchmaking.ts